var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPointLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9L1 5M1 5L4.75 0.999998M1 5L11 5",
    stroke: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointLeft);
export default __webpack_public_path__ + "static/media/arrow-point-left.ca8b5597ccd6e05d3029edfb413357fc.svg";
export { ForwardRef as ReactComponent };